'use client';

import useGetClips from 'hooks/useGetClips';

export const SPOTLIGHT_CLIPS_PARAMS = {
  sort: 'approvedAt',
  direction: 'desc',
  size: 12,
} as const;

const useHasSpotlightClips = (offeringId?: string) => {
  const { data, isLoading } = useGetClips(
    { offeringId, ...SPOTLIGHT_CLIPS_PARAMS },
    { enabled: Boolean(offeringId) },
  );
  if (!offeringId) return { hasClips: false, isLoading: false };
  const total = data?.pages?.[0]?.totalElements ?? 0;
  return { hasClips: total > 0, isLoading };
};

export default useHasSpotlightClips;
